import Controller from './Controller'
import { trace } from 'rytm-helpers'

import ReCaptchaController from './ReCaptchaController'

class AlumniFormController extends ReCaptchaController {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    // jedno z dwóch pól jest wymagane!
    // const inputs = Array.from(document.querySelectorAll('input[name=email], textarea'));
    const inputs = Array.from(document.querySelectorAll('input[name=email], input[name=numer-telefonu]'));
    const inputListener = e => inputs.filter(i => i !== e.target).forEach(i => i.required = !e.target.value.length);
    inputs.forEach(i => i.addEventListener('input', inputListener));
    // ustawiam oba jako wymagane na start
    inputs.forEach(i => i.required = true)
  }
  addEventListeners() {
    super.addEventListeners()
    
  }
  removeEventListeners() {
    super.removeEventListeners()
    
  }
  /**
   * OWN
   */
  
}

export default AlumniFormController;